import { useEffect, useRef, useState } from "react";
import { ArrowRight, Truck } from "lucide-react";

/**
 * Carte CTA "Besoin d'un déménageur ?" qui glisse depuis la droite
 * en bas de l'écran quand l'utilisateur scrolle vers le bas, et
 * disparaît dès qu'il scrolle vers le haut. Mobile uniquement.
 */
const StickyMobileMoverCTA = () => {
  const [visible, setVisible] = useState(false);
  const lastYRef = useRef(0);

  useEffect(() => {
    lastYRef.current = window.scrollY;
    let ticking = false;
    const SHOW_AFTER = 220; // ne pas montrer avant 220 px de scroll
    const DELTA = 6; // ignore les micro-mouvements

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const dy = y - lastYRef.current;
        if (Math.abs(dy) > DELTA) {
          if (dy > 0 && y > SHOW_AFTER) {
            setVisible(true);
          } else if (dy < 0) {
            setVisible(false);
          }
          lastYRef.current = y;
        }
        ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      aria-hidden={!visible}
      className={`md:hidden fixed left-3 right-3 bottom-1 z-40 transition-transform duration-300 ease-out ${
        visible ? "translate-x-0" : "translate-x-[120%]"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="sticky-mover-cta"
    >
      <div className="flex items-center gap-2 rounded-2xl bg-white text-[#237cb5] pl-2.5 pr-1.5 py-1.5 shadow-[0_18px_30px_-12px_rgba(15,29,43,0.25)] border-2 border-[#237cb5]">
        <span className="flex items-center justify-center h-7 w-7 rounded-full bg-[#237cb5] text-white shrink-0">
          <Truck className="h-3.5 w-3.5" strokeWidth={2.4} />
        </span>
        <span className="flex-1 min-w-0 text-[12.5px] font-extrabold truncate text-[#0f1d2b]">
          Besoin d&apos;un déménageur&nbsp;?
        </span>
        <a
          href="https://bigdemenagement.fr/"
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={visible ? 0 : -1}
          className="shrink-0 inline-flex items-center gap-1 h-8 px-2.5 rounded-lg bg-[#FF7A00] active:bg-[#E66E00] text-white text-[12px] font-bold whitespace-nowrap [-webkit-tap-highlight-color:transparent]"
          data-testid="sticky-mover-cta-button"
        >
          Devis gratuit
          <ArrowRight className="h-3 w-3" strokeWidth={2.6} />
        </a>
      </div>
    </div>
  );
};

export default StickyMobileMoverCTA;
